import { visionService } from "@/services/vision-service";
import { reportError } from "@/utils/observability";
import type { ProposalPayload } from "../ai-mode/types";

/** SWR key for a client-facing proposal fetch — shared by ProposalRoutePage
 * (which fetches first to pick the template) and this page's own live flow,
 * so the resolver's request is the page's request (deduped by key). */
export function proposalSwrKey(uuid: string): string {
  return `proposal-smb/${uuid}`;
}

export async function loadProposal(
  uuid: string,
): Promise<ProposalPayload | null> {
  try {
    const proposal = await visionService.getProposal(uuid);
    return proposal;
  } catch (error) {
    reportError(error, { operation: "getProposal", proposalId: uuid });
    throw error;
  }
}
